export const PROGRESSION_DIRECTION_ASC = 1
export const PROGRESSION_DIRECTION_DESC = -1

export const VALID_PROGRESSION_DIRECTION = [PROGRESSION_DIRECTION_DESC, PROGRESSION_DIRECTION_ASC]
